import { render, staticRenderFns } from "./TwoFactorForm.vue?vue&type=template&id=7fff25bc&scoped=true&"
import script from "./TwoFactorForm.vue?vue&type=script&lang=ts&"
export * from "./TwoFactorForm.vue?vue&type=script&lang=ts&"
import style0 from "./TwoFactorForm.vue?vue&type=style&index=0&id=7fff25bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fff25bc",
  null
  
)

export default component.exports